import { IShoppingCartProduct } from '@monofront/types';
import { useTranslations } from 'next-intl';
import { useGroupCartProductsByType as useGroupCartProductsByTypeBase } from '@monofront/business/hooks';

const useGroupCartProductsByType = (
  shoppingCartProduct?: IShoppingCartProduct[],
) => {
  const tCart = useTranslations('Cart');
  const fallbackLabel = tCart('other');

  return useGroupCartProductsByTypeBase(
    shoppingCartProduct || [],
    fallbackLabel,
  );
};

export default useGroupCartProductsByType;
